<template>
  <div>
    <b-modal ref="PartnerCommissionModal" :title="modalTitle" :no-close-on-backdrop="true">
      <b-row>
        <b-col cols="3">
          <label>{{$t('labels.common.agent')}}</label>
        </b-col>
        <b-col>
          <multiselect v-model="commission.agent" :max-height="200"
                       placeholder="" label="name" track-by="id"
                       :disabled="(isCommissionEditing || (isCommissionCreating && !this.roles.customer && !this.roles.supplier))"
                       :class="{ required: !commission.agent}" @select="selectAgentCommissions"
                       :options="agents" :close-on-select="true"></multiselect>
        </b-col>
      </b-row>
      <b-row v-show="isCommissionCopying">
        <b-col cols="3">
          <label>{{$t('labels.agents.commissions')}}</label>
        </b-col>
        <b-col>
          <multiselect v-model="commission.comissions" :max-height="200"
                       placeholder="" label="description" track-by="id"
                       :class="{ required: !commission.comissions.length}" :multiple="true"
                       :options="agentCommissions" :close-on-select="false"></multiselect>
        </b-col>
      </b-row>
      <b-row v-show="isCommissionEditing || isCommissionCreating">
        <b-col cols="3">
          <label>{{$t('labels.agents.commission_type')}}</label>
        </b-col>
        <b-col>
          <multiselect v-model="commission.type" :max-height="200"
                       placeholder="" label="name" track-by="name"
                       :options="commissionTypes" :close-on-select="true"
                       :class="{ required: !commission.type}"
                       @input="autoCompleteCommCurrency"></multiselect>
        </b-col>
      </b-row>
      <b-row v-show="isCommissionEditing || isCommissionCreating">
        <b-col cols="3">
          <label>{{$t('labels.agents.commission_currency')}}</label>
        </b-col>
        <b-col>
          <multiselect v-model="commission.currency" :max-height="200"
                       placeholder="" label="code" track-by="code"
                       :class="{ required: commission.type && !commission.currency}"
                       :disabled="!commission.type || isCommCurrencyNotEditable"
                       :options="currencies" :close-on-select="true"></multiselect>
        </b-col>
      </b-row>
      <b-row v-show="isCommissionEditing || isCommissionCreating">
        <b-col cols="3">
          <label>{{$t('labels.agents.commission_uom')}}</label>
        </b-col>
        <b-col>
          <multiselect v-model="commission.measure_type" :max-height="200"
                       placeholder=""
                       :disabled="!commission.type || isWoodOrUomNotEditable"
                       :class="{ required: !commission.measure_type && commission.type}"
                       :options="measure_types" :close-on-select="true"></multiselect>
        </b-col>
      </b-row>
      <b-row v-show="(isCommissionEditing || isCommissionCreating) && (this.roles.purchase_agent || this.roles.supplier)">
        <b-col cols="3">
          <label>{{$t('labels.common.wood')}}</label>
        </b-col>
        <b-col>
          <multiselect v-model="commission.trees" :max-height="200" :searchable="true"
                       label="name" track-by="name" :options="wood"
                       :multiple="true" :close-on-select="false"
                       :disabled="!commission.type || isWoodOrUomNotEditable"
                       placeholder=""
          ></multiselect>
        </b-col>
      </b-row>
      <b-row v-show="(isCommissionEditing || isCommissionCreating) && (this.roles.purchase_agent || this.roles.supplier)">
        <b-col cols="3">
          <label>{{$t('labels.common.product_group')}}</label>
        </b-col>
        <b-col>
          <multiselect v-model="commission.product_group" :max-height="200" :searchable="true"
                       label="name" track-by="name" :options="movement_groups"
                       multiple :close-on-select="false"
                       :disabled="!commission.product_group || (isWoodOrUomNotEditable && !isCommTypeSumm)"
                       placeholder=""
          ></multiselect>
        </b-col>
      </b-row>
      <b-row v-show="isCommissionEditing || isCommissionCreating">
        <b-col cols="3">
          <label>{{$t('labels.agents.commission_value')}}</label>
        </b-col>
        <b-col>
          <input class="form-control" placeholder=""
                 v-digits-after-decimal="{numberOfDigits: 2}"
                 :disabled="!commission.type"
                 :class="{ required: !commission.value && commission.type}"
                 v-model="commission.value">
        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100 text-center">
        <b-btn size="sm" variant="success" @click="saveCommission">
          {{$t('buttons.common.save')}}
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect';
  import {
    mapState
  } from 'vuex';
  import { notificationsRenderer } from '@/helpers/renderHelpers';
  import {
    getArrayByProperty,
    handlerResponse,
    cleanFilters,
    setNotifyData
  } from '@/helpers/commonHelpers';

  export default {
    components: {
      Multiselect
    },
    props: ['partner_id'],
    data() {
      return {
        agentCommissions: [],
        roles: '',
        mode: '',
        commission: {
          type: '',
          currency: '',
          measure_type: '',
          customer: '',
          value: '',
          agent: '',
          comissions: [],
          product_group: [],
          trees: []
        }
      }
    },
    methods: {
      saveDataRequest(saveData, agentType = 'sale') {
        if (this.isCommissionCreating) {
          this.$http.post(`accounting/${agentType}_agent_commissions/`, saveData).then(() => {
            this.$notify(setNotifyData('Success', 'Commission has been created!', 'success'));
            this.$root.$emit('updatePartnerCommissionsList');
            this.$refs['PartnerCommissionModal'].hide();
          }).catch((error) => {
            console.log(error);
            notificationsRenderer(error.body, 'error')
          })
        }
        if (this.isCommissionEditing) {
          this.$http.put(`accounting/${agentType}_agent_commissions/${this.commission.id}/`, saveData).then(handlerResponse).then((response) => {
            this.$notify(setNotifyData('Success', 'Commission has been updated!', 'success'));
            this.$root.$emit('updatePartnerCommissionsList');
            this.$refs['PartnerCommissionModal'].hide();
          }).catch((error) => {
            console.log(error);
            notificationsRenderer(error.body, 'error')
          })
        }
      },
      saveCommission() {
        let saveData = {
          type: this.commission.type ? this.commission.type.key : null,
          currency: this.commission.currency ? this.commission.currency.id : null,
          measure_type: this.commission.measure_type,
          agent: this.commission.agent ? this.commission.agent.id : null,
          customer: this.commission.customer ? this.commission.customer.id : null,
          value: this.commission.value
        };
        if (this.roles.purchase_agent || this.roles.supplier) {
          saveData = {
            ...saveData,
            trees: getArrayByProperty(this.commission.trees, 'id'),
            product_group: getArrayByProperty(this.commission.product_group, 'id'),
            supplier: this.commission.supplier ? +this.commission.supplier.id : null
          }
        }
        if (this.roles.sale_agent || this.roles.customer) {
          this.saveDataRequest(saveData);
        } else {
          this.saveDataRequest(saveData, 'purchase');
        }
        if (this.isCommissionCopying) {
          const agentType = this.roles.sale_agent || this.roles.customer ? 'sale' : 'purchase';
          let duplicatedCommissions = {
            commission_ids: getArrayByProperty(this.commission.comissions, 'id')
          };
          if (agentType === 'sale') {
            duplicatedCommissions.customer_id = this.partner_id
          } else {
            duplicatedCommissions.supplier_id = this.partner_id
          }
          this.$http.post(`accounting/${agentType}_agent_commissions/duplicate/`, duplicatedCommissions).then((response) => {
            this.$notify(setNotifyData('Success', 'Commission has been created!', 'success'));
            this.$root.$emit('updatePartnerCommissionsList');
            this.$refs['PartnerCommissionModal'].hide();
          }).catch((error) => {
            console.log(error);
            notificationsRenderer(error.body, 'error')
          })
        }
      },
      selectAgentCommissions(agent) {
        const agentType = this.roles.sale_agent || this.roles.customer ? 'sale' : 'purchase';
        if (this.isCommissionCopying) {
          this.$http.get(`accounting/${agentType}_agent_commissions_list/`, {params: {agent_id: agent.id}}).then(handlerResponse).then((response) => {
            this.agentCommissions = response;
          })
        }
      },
      autoCompleteCommCurrency() {
        if (this.isCommTypeSumm) {
          //set EUR as default currency
          this.commission.currency = this.currencies.find(e => e.id === 1);
        }
      }
    },
    computed: {
      ...mapState('generic', ['currencies', 'commissionTypes']),
      ...mapState('woodware', ['measure_types', 'wood', 'movement_groups']),
      ...mapState('partners', ['agents']),
      isCommTypeSumm() {
        return this.commission.type && (this.commission.type.key === '%(inv-tr)' || this.commission.type.key === '%(inv)')
      },
      isCommCurrencyNotEditable() {
        return ((this.roles.customer || this.roles.sale_agent) && this.isCommTypeSumm)
          || ((this.roles.supplier || this.roles.purchase_agent) && this.commission.type && !(this.commission.type.key === 'crncy|uom' || this.commission.type.key === 'fix'));
      },
      isWoodOrUomNotEditable() {
        return (this.roles.supplier || this.roles.purchase_agent) && !this.isCommTypeCurrUom;
      },
      isCommTypeCurrUom() {
        return this.commission.type && (this.commission.type.key === 'crncy|uom');
      },
      isCommissionEditing() {
        return this.mode === 'edit';
      },
      isCommissionCreating() {
        return this.mode === 'create';
      },
      isCommissionCopying() {
        return this.mode === 'copy';
      },
      modalTitle() {
        return `${this.$i18n.t('modal_dialogs.partner.commission')}`;
      }
    },
    mounted() {
      this.$root.$on('openPartnerCommissionModal', async (data) => {
        cleanFilters(this.commission);
        this.mode = data.mode;
        this.roles = data.roles;
        this.commission = {...this.commission, ...data.commissionData};
        if (data.commissionData.purchase_agent) {
          this.selectAgentCommissions(data.commissionData.purchase_agent);
          this.commission.agent = data.commissionData.purchase_agent;
        } else if (data.commissionData.sale_agent){
          this.selectAgentCommissions(data.commissionData.sale_agent);
          this.commission.agent = data.commissionData.sale_agent;
        }
        if (this.roles.purchase_agent || this.roles.supplier) {
          await this.$store.cache.dispatch('woodware/getWood');
          await this.$store.cache.dispatch('woodware/loadMovementGroups');
        }
        this.$refs['PartnerCommissionModal'].show();
      })
    },
    beforeDestroy() {
      this.$root.$off('openPartnerCommissionModal');
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/PartnerCommissionModal.vue